module.exports = __webpack_public_path__ + "img/1f923.0ceccf6.svg";